import affiliatesJson from './content/affiliates.json';

export const affiliatesMock = {
    layoutType: 2,
    data: {
        name: 'affiliates',
        areasList: [
            {
                id: 1,
                name: 'AffiliatesPage',
                componentName: 'Comp:AffiliatesPage',
                content: JSON.stringify(affiliatesJson)
            }
        ]
    }
};
